import { useRef } from "react";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ManifestoChapters from "@/components/ManifestoChapters";
import AboutSpeaker from "@/components/AboutSpeaker";
import Reviews from "@/components/Reviews";
import BookingForm from "@/components/BookingForm";

export default function EventPage() {
  const scrollToBook = () => {
    document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main data-testid="event-page">
      <header className="fixed top-0 inset-x-0 z-50 flex items-center justify-between px-6 sm:px-10 lg:px-16 py-5 mix-blend-difference">
        <span />
        <button
          data-testid="nav-book-btn"
          onClick={scrollToBook}
          className="uppercase tracking-[0.2em] text-[11px] text-[var(--cream)] border-b border-[var(--gold)] pb-1 hover:text-[var(--gold)] transition-colors duration-200"
        >
          Book
        </button>
      </header>

      <KineticHero onBook={scrollToBook} />
      <EditorialMarquee />
      <ManifestoChapters />
      <AboutSpeaker />
      <Reviews />
      <BookingForm />

      <footer className="px-6 sm:px-10 lg:px-16 py-14 border-t border-[rgba(201,162,74,0.18)] text-center">
        <p className="font-display text-2xl text-[var(--cream)]">The Horseshoe</p>
        <p className="font-body text-sm text-[var(--muted)] mt-2">Chipping Sodbury · Over 18s only</p>
        <p className="font-body text-xs text-[var(--muted)] mt-6">hello@horseshoepub.co.uk</p>
      </footer>
    </main>
  );
}
